<template>
    <div class="home">
      <h1>达芬奇密码</h1>
      
      <div class="action-buttons">
        <button @click="showCreate = true" class="create-button">
          Create New Game
        </button>
        <button @click="showJoin = true" class="join-button">
          Join Existing Game
        </button>
      </div>
      
      <GameLobby 
        v-if="showCreate" 
        @close="showCreate = false" 
      />
      
      <AvailableGames 
        v-if="showJoin" 
        @close="showJoin = false" 
      />
    </div>
  </template>
  
  <script>
  import { ref } from 'vue'
  import GameLobby from '@/components/GameLobby.vue'
  import AvailableGames from '@/components/AvailableGames.vue'
  
  export default {
    name: 'HomeView',
    components: { GameLobby, AvailableGames },
    
    setup() {
      const showCreate = ref(false)
      const showJoin = ref(false)
  
      return { showCreate, showJoin }
    }
  }
  </script>
  
  <style scoped>
  .home {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  }
  
  h1 {
    color: #2c3e50;
    margin-bottom: 30px;
  }
  
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .create-button, .join-button {
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .create-button {
    background-color: #007bff;
    color: white;
  }
  
  .create-button:hover {
    background-color: #0069d9;
  }
  
  .join-button {
    background-color: #28a745;
    color: white;
  }
  
  .join-button:hover {
    background-color: #218838;
  }
  </style>